import { useState } from 'react';
import { useDebounce, useMountedState } from 'react-use';

import { handleError, productsApi } from '@mssgme/lib';
import { useFetching } from '@mssgme/hooks';

export const useProductsApi = ({ workspaceId, websiteId, query }) => {
    const isMounted = useMountedState();
    const [store, setStore] = useState({ hasNext: false, next: null, publishedCount: 0, items: [], isFetching: true });
    const { pending: isFetching, run: getProducts } = useFetching(
        async (resetStore) => {
            const { results, next, ...productsStore } = await productsApi.list(workspaceId, {
                limit: query.limit,
                next: resetStore ? null : store.next,
                collection: query.collections.include,
                website: websiteId,
                published: true,
            });

            if (!isMounted()) {
                return;
            }

            setStore((prevProducts) => {
                const items = resetStore ? results : prevProducts.items.concat(results);
                const hasNext = productsStore.hasNext && !(query.total && items.length >= query.total);

                return {
                    ...productsStore,
                    next: (hasNext && next) || null,
                    items: query.total ? items.slice(0, query.total) : items,
                    hasNext,
                };
            });
        },
        [store.next, query]
    );

    useDebounce(() => void getProducts(true).catch(handleError), 100, [query]);

    return {
        ...store,
        isFetching: store.isFetching || isFetching,
        getProducts,
    };
};
